import { routesPath } from "./routesPath";
import {
    Loadable_Company,
    Loadable_Home,
    Loadable_Loading,
    Loadable_Login,
    Loadable_OrderForm,
    Loadable_BasicLogin,
} from "config/LoadableConfig";
import { APP_VERSION } from "../variables/staticValue";
import { getVersionWithoutBuildNumber } from "../helper/helper";
import { t } from "@lingui/macro";
import { trans } from "../config/LinguiConfig";

let pathParent = `/${getVersionWithoutBuildNumber(APP_VERSION)}`;

export const getAppRoutes = () => [
    // {
    //     path: pathParent,
    //     name: "Doopage",
    //     component: Text,
    // },
    {
        private: true,
        path: routesPath.home,
        name: trans(t`Trang chủ`),
        component: Loadable_Home,
    },
    {
        private: true,
        path: routesPath.company,
        name: trans(t`Tạo công ty`),
        component: Loadable_Company,
    },
    {
        path: routesPath.order_form,
        name: trans(t`Đặt hàng`),
        component: Loadable_OrderForm,
    },
    {
        path: routesPath.login,
        name: trans(t`Đăng nhập`),
        component: Loadable_Login,
    },
    {
        path: routesPath.basic_login,
        name: trans(t`Đăng nhập username password`),
        component: Loadable_BasicLogin,
    },
    {
        path: pathParent,
        name: "DooPage",
        component: Loadable_Loading,
    },
    {
        path: "",
        name: "DooPage",
        component: Loadable_Loading,
    },
];

// Backward compatibility - keep this for existing code that uses appRoutes
export const appRoutes = getAppRoutes();
